import parse from 'html-react-parser';
import { marked } from 'marked';
import React, { useEffect } from 'react';
import addWidgetIcon from '../../assets/img/widget-add.svg';
import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import { Dashboard, Db2Database, Edit } from '@carbon/icons-react';

type Props = {
    addWidget?: () => void;
    noData?: boolean;
    roles?: string[];
    stageViewMode?: any;
};

const EmptyState = ({ addWidget, noData, roles, stageViewMode }: Props) => {
    const classes = useStyles();
    const [t] = useTranslation();
    const markedText_1: any = marked(t('COMMON.NO_WIDGETS_CREATED_TEXT_HINT_1'));
    const markedText_2: any = marked(t('COMMON.NO_WIDGETS_CREATED_TEXT_HINT_2'));

    return (
        <div className={classes.noWidgetsWrapper}>
            {noData ? (
                <div className={classes.noDataWrapper}>
                    <Db2Database />
                    <div className={[classes.textWrapper, classes.noData].join(' ')}>
                        <Typography variant="h6">
                            <span>{t('WIDGET_EDITOR.CHART_NO_DATA_LABEL')}</span>
                        </Typography>
                    </div>
                </div>
            ) : (
                <>
                    <div className={[classes.noWidgetsImg, classes.halfOpacity].join(' ')}>
                        {stageViewMode === 'PUBLISHED' ? <Dashboard /> : <img src={addWidgetIcon} alt="Add widget" />}
                    </div>
                    {roles?.some((role) => ['SuperUser', 'Admin', 'Designer'].includes(role)) ? (
                        <div className={classes.noWidgetsText}>
                            <div className={classes.textWrapper}>
                                <Typography variant="h4">{t('COMMON.NO_WIDGETS_CREATED_TEXT_1')}</Typography>
                            </div>
                            {stageViewMode === 'WORK_IN_PROGRESS' ? (
                                <div className={classes.addWidgetCta}>
                                    <Button variant="contained" color="primary" onClick={addWidget}>
                                        {t('COMMON.ADD_FIRST_WIDGET_BUTTON')}
                                    </Button>
                                </div>
                            ) : (
                                <div className={classes.textWrapper}>
                                    <Typography variant="h6">
                                        <span>
                                            {parse(markedText_1)} <Edit /> {parse(markedText_2)}
                                        </span>
                                    </Typography>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className={classes.noWidgetsText}>
                            <div className={classes.textWrapper}>
                                <Typography variant="h4">{t('COMMON.NO_WIDGETS_CREATED_TEXT_2')}</Typography>
                            </div>
                            <div className={classes.textWrapper}>
                                <Typography variant="h6">{t('COMMON.NO_WIDGETS_CREATED_TEXT_VIEWER')}</Typography>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default EmptyState;
